import { render, staticRenderFns } from "./web-push-setting-form.vue?vue&type=template&id=59db227c"
import script from "./web-push-setting-form.vue?vue&type=script&lang=js"
export * from "./web-push-setting-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports